import {
  registrationSchedule2026Fall,
  normalizeRegistrationGrade,
  phaseState,
  formatKstMoment,
  calendarDaysUntil,
} from '../data/courseRegistrationSchedule'

// 정정기간(adjustment) 시작 = 개강일 09:00. 별도 "개강" 날짜를 새로 정의하지 않고
// 이 값을 그대로 재사용한다 — 두 일정이 실제로 같은 시각이기 때문.
export const SEMESTER_START_AT = registrationSchedule2026Fall.adjustment.startAt

export function isBeforeSemesterStart(now = new Date()) {
  return now < new Date(SEMESTER_START_AT)
}

function buildStages(grade) {
  const s = registrationSchedule2026Fall
  const stages = [{ ...s.preRegistration, kicker: '예비수강신청' }]
  if (grade) stages.push({ ...s.byGrade[grade], kicker: `${grade}학년 본수강신청` })
  stages.push(
    { ...s.adjustment, kicker: '정정기간' },
    { ...s.finalAdjustment, kicker: '최종정정' },
    { ...s.cancellation, kicker: '수강취소' },
  )
  return stages
}

// 24시간 이내로 가까우면 초 단위 카운트다운, 아니면 D-day. (카운트다운 규칙 참고)
function resolveBig(targetAt, now) {
  const hoursLeft = (new Date(targetAt) - now) / 3_600_000
  if (hoursLeft < 24) return { mode: 'countdown', targetAt }
  return { mode: 'dday', value: `D-${calendarDaysUntil(new Date(targetAt), now)}` }
}

function buildMetaLine({ grade, kicker }) {
  return [registrationSchedule2026Fall.semesterLabel, grade ? `${grade}학년` : null, kicker]
    .filter(Boolean).join(' · ')
}

/** 개강 전 홈 Hero용 상태. 우선순위: 진행 중인 단계 > 가장 가까운 다음 단계
 * (정정기간=개강일이면 "개강"으로 재라벨링) > (도달 불가) 전체 일정 종료. */
export function getRegistrationHeroState({ now = new Date(), grade } = {}) {
  const normalizedGrade = normalizeRegistrationGrade(grade)
  const stages = buildStages(normalizedGrade)

  for (const stage of stages) {
    const state = phaseState(stage, now)
    const isSemesterStart = stage.id === 'adjustment'

    if (state === 'active' && now < new Date(stage.endAt)) {
      return {
        phaseId: stage.id,
        label: `${stage.kicker} 진행중`,
        big: resolveBig(stage.endAt, now),
        caption: `${formatKstMoment(new Date(stage.endAt))} 종료`,
        prompt: '마감 전에 시간표와 신청 준비를 확인하세요',
        metaLine: buildMetaLine({ grade: normalizedGrade, kicker: stage.kicker }),
      }
    }
    if (state === 'upcoming') {
      return {
        phaseId: isSemesterStart ? 'semester-start' : stage.id,
        label: isSemesterStart ? '개강' : stage.kicker,
        big: resolveBig(stage.startAt, now),
        caption: isSemesterStart
          ? `${formatKstMoment(new Date(stage.startAt))} 개강`
          : `${formatKstMoment(new Date(stage.startAt))} 시작`,
        prompt: isSemesterStart
          ? '수강정정은 개강일 09:00에 시작해요'
          : normalizedGrade
            ? '지금 시간표와 신청 준비를 확인하세요'
            : '학년을 설정하면 내 본수강신청 일정을 알려드려요',
        metaLine: buildMetaLine({ grade: normalizedGrade, kicker: stage.kicker }),
      }
    }
  }

  return {
    phaseId: 'completed',
    label: `${registrationSchedule2026Fall.semesterLabel} 수강신청 일정 종료`,
    big: { mode: 'text', value: registrationSchedule2026Fall.semesterLabel },
    caption: null,
    prompt: '수강신청 허브에서 결과를 확인하세요',
    metaLine: registrationSchedule2026Fall.semesterLabel,
  }
}
